var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ckedito_content"},[_c('ckeditor',{attrs:{"id":"editor1","content":_vm.infoText},on:{"sendContnet":_vm.getContent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }